/**
 * Formata um valor numérico (em reais, com casas decimais) como string BRL.
 * Único ponto de formatação de moeda do sistema — usado tanto na API
 * (ex: montar mensagem de notificação) quanto no frontend.
 */
export function formatBRL(valor) {
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).format(valor);
}
/**
 * Converte um valor em reais para centavos (inteiro).
 * Toda persistência monetária no banco deve usar centavos (integer),
 * nunca float — isso evita erros de arredondamento no financeiro.
 */
export function reaisParaCentavos(reais) {
    return Math.round(reais * 100);
}
/**
 * Converte centavos (inteiro, como vem do banco) para reais (número decimal).
 */
export function centavosParaReais(centavos) {
    return centavos / 100;
}
//# sourceMappingURL=currency.js.map